import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Text = styled(Typography.Body)<{
  $hasError?: boolean;
  $hasBottomMargin?: boolean;
  $hasTopMargin?: boolean;
  $align?: 'left' | 'right';
}>`
  margin-top: ${({ $hasTopMargin }) => ($hasTopMargin ? '5px' : '0')};
  margin-bottom: ${({ $hasBottomMargin }) => ($hasBottomMargin ? '5px' : '0')};
  color: ${({ theme, $hasError }) =>
    $hasError ? theme.palette.system.red : theme.palette.primary.labels};
  text-align: ${({ $align }) => $align};
`;
